import { lazy } from "react";

export { COUNTERPARTY_TAGS_LIST_PATH } from "./counterparty-tag-list-path";
export const CounterpartyTagsList = lazy(
  () => import("./counterparty-tag-list"),
);
